// Settings
export const FACULTY_ENABLED_ALWAYS: boolean = true; // Overrides the existing local storage mechanism and makes faculty links public temporarily for specific faculty events.

// Constants
export const URL_INTERCOM_SUPPORT: string = 'https://intercom.help/collegiate-mobile-help-center/en/';
export const PAGE_TITLE: string = ' | Support Your University Just By Paying Your Phone Bill';

export const SHARED_IMAGE_PATH = 'assets/shared/';

export const IMAGE_FAVICON = '/favicon.ico';

// Shared images
export const DEFAULT_PAGE_FAVICON = SHARED_IMAGE_PATH + 'favicon.png';
export const DEFAULT_PAGE_BG0 = SHARED_IMAGE_PATH + 'bg0.jpg';
export const DEFAULT_PAGE_BG1 = SHARED_IMAGE_PATH + 'bg1.jpg';
export const DEFAULT_PAGE_BG2 = SHARED_IMAGE_PATH + 'bg2.jpg';
export const DEFAULT_PAGE_BG3 = SHARED_IMAGE_PATH + 'bg3.jpg';
export const DEFAULT_PAGE_BG4 = SHARED_IMAGE_PATH + 'bg4.jpg';
export const DEFAULT_PAGE_BG5 = SHARED_IMAGE_PATH + 'bg5.jpg';

// Default page images array
export const DEFAULT_PAGE_BACKGROUND_IMAGES = [
	DEFAULT_PAGE_BG0,
	DEFAULT_PAGE_BG1,
	DEFAULT_PAGE_BG2,
	DEFAULT_PAGE_BG3,
	DEFAULT_PAGE_BG4,
	DEFAULT_PAGE_BG5,
];